<div class="di-confirmation-dossier-patient">
	<div class="dialog-content">
		<p>Attention, cette action est irréversible. Les données du dossier seront mises à jour avec celles de la carte Vitale et les informations remplacées ne pourront pas être récupérées.</p>
		<lua-action-secondaire libelle="Continuer" color="CouleurPrimaire" [fullWidth]="true"
			[avecIcone]="false" size="medium" [isDisabled]="false" positionIcone="L"
			(click)="onConfirm()"></lua-action-secondaire>
		<lua-bouton-texte libelle="Annuler" color="CouleurPrimaire" [fullWidth]="true" [isDisabled]="false"
			endIcon="" type="button" size="medium" (click)="onCancel()"></lua-bouton-texte>
	</div>
</div>